export default __webpack_public_path__ + "4a13e16805054f7575fc196d52ae1851.png";